var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "career-list-item" }, [
    _c(
      "div",
      { staticClass: "flex flex-row justify-between career-list-item__row" },
      [
        _c("div", { staticClass: "career-list-item__row--header" }, [
          _vm._v("\n      " + _vm._s(_vm.node.name) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-row" },
          [
            _vm._v("\n      Is this current?\n      "),
            _c("toggle-button", {
              staticClass: "margin-x-2",
              attrs: {
                sync: true,
                color: { checked: _vm.brandPrimary, unchecked: "#b7b7b7" },
                labels: { checked: "YES", unchecked: "NO" },
              },
              on: {
                input: (value) => {
                  _vm.$emit("toggleRetired", _vm.node, value)
                },
              },
              model: {
                value: _vm.node.current,
                callback: function ($$v) {
                  _vm.$set(_vm.node, "current", $$v)
                },
                expression: "node.current",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "delete-button" }, [
              _c("i", {
                staticClass: "fa fa-times",
                on: {
                  click: () => {
                    _vm.$emit("delete", _vm.node)
                  },
                },
              }),
            ]),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex flex-row career-list-item__row career-list-item__row--highlight",
      },
      [
        !_vm.node.pending
          ? _c(
              "div",
              { staticClass: "flex flex-row" },
              [
                _vm._l(_vm.node.ancestors, function (ancestor) {
                  return _c("div", { key: ancestor.id, staticClass: "flex" }, [
                    _c("div", [
                      _vm._v(
                        "\n          " + _vm._s(ancestor.name) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "spacer-x-2" }, [_vm._v(">")]),
                  ])
                }),
                _vm._v("\n      " + _vm._s(_vm.node.name) + "\n    "),
              ],
              2
            )
          : _c("div", [_vm._v("\n      Under review\n    ")]),
        _vm._v(" "),
        _vm.node.has_children
          ? _c(
              "div",
              { staticClass: "flex flex-row" },
              [
                _c("div", { staticClass: "spacer-x-2" }, [_vm._v(">")]),
                _vm._v(" "),
                !_vm.searching
                  ? _c(
                      "button",
                      {
                        staticClass: "add-tag-button",
                        on: { click: _vm.startSearching },
                      },
                      [
                        _c("i", { staticClass: "fa fa-pencil" }),
                        _vm._v(" Add tag"),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.searching
                  ? _c("tag-picker", {
                      attrs: {
                        "input-id": "search" + _vm.node.id,
                        current: _vm.current,
                        placeholder: "Search",
                        "full-width": false,
                        "parent-node": _vm.node.id,
                        maximum: 6,
                        "can-add": false,
                      },
                      on: {
                        selected: (option) => {
                          _vm.$emit("selected", option, _vm.node.id)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }